export default __webpack_public_path__ + "youtube-logo.png";